import * as React from 'react';
import { Dispatch } from 'redux';
import { Provider, connect } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Store } from 'redux';
import { History } from 'history';
import { LayoutPage } from './pages/LayoutPage';
import { ApplicationState } from './store';
import { fetchRequestCountries, fetchRequestModels, fetchRequestInfotaiments, fetchRequestImporterSettings } from './store/common/actions';

interface PropsFromDispatch {
	[key: string]: any,
	fetchRequestCountries: typeof fetchRequestCountries,
	fetchRequestModels: typeof fetchRequestModels,
	fetchRequestInfotaiments: typeof fetchRequestInfotaiments,
	fetchRequestImporterSettings: typeof fetchRequestImporterSettings
}

// Any additional component props go here.
interface OwnProps {
	store: Store<ApplicationState>
	history: History
}

// Create an intersection type of the component props and our Redux props.
type AllProps = PropsFromDispatch & OwnProps

class Main extends React.Component<AllProps> {

	public componentDidMount() {
		this.props.fetchRequestCountries();
		this.props.fetchRequestModels();
		this.props.fetchRequestInfotaiments();
		this.props.fetchRequestImporterSettings();
	}

	public render() {
		const { store, history, theme } = this.props

		return (
			<Provider store={store}>
				<ConnectedRouter history={history}>
					<LayoutPage />
				</ConnectedRouter>
			</Provider>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchRequestCountries: () => dispatch(fetchRequestCountries()),
	fetchRequestInfotaiments: () => dispatch(fetchRequestInfotaiments()),
	fetchRequestModels: () => dispatch(fetchRequestModels()),
	fetchRequestImporterSettings: () => dispatch(fetchRequestImporterSettings())
})

export default connect(
	null,
	mapDispatchToProps
)(Main)
